import { CSSProperties } from 'react';

export default function ContactIcon({ s }: { s?: CSSProperties }) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...s, verticalAlign: 'middle ' }}
    >
      <circle cx="20" cy="20" r="20" fill="url(#paint0_linear_3627_2531)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5418 11.9383C25.5438 10.6278 25.082 9.3588 24.2383 8.35598H24.2384C23.2155 7.13821 21.682 6.36426 19.9676 6.36426C16.8889 6.36426 14.3936 8.86018 14.3936 11.9383C14.3936 15.0166 16.8895 17.5125 19.9676 17.5125C23.0458 17.5125 25.5418 15.0166 25.5418 11.9383ZM7.87891 30.2273H19.5289H32.0851L32.1213 29.0919C32.1213 24.8394 28.6735 21.3916 24.4209 21.3916H15.6154C11.363 21.3916 7.91511 24.8394 7.91511 29.0919L7.87891 30.2273Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3627_2531"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6F3DFD" />
          <stop offset="1" stopColor="#1399D6" />
        </linearGradient>
      </defs>
    </svg>
  );
}
